import React from 'react';
import { motion } from 'framer-motion';
import { OFFER_STEPS } from './offerData';

const OfferSteps: React.FC = () => (
  <section className="relative py-16 md:py-20 bg-[#36393F] overflow-hidden">
    <div className="pointer-events-none absolute inset-0">
      <motion.div
        className="absolute -top-24 left-[10%] h-56 w-56 rounded-full bg-[#5865F2]/20 blur-3xl"
        animate={{ x: [0, 20, -8, 0], y: [0, -12, 14, 0] }}
        transition={{ duration: 12, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.div
        className="absolute -bottom-24 right-[6%] h-72 w-72 rounded-full bg-cyan-400/10 blur-3xl"
        animate={{ x: [0, -24, 10, 0], y: [0, 12, -18, 0] }}
        transition={{ duration: 14, repeat: Infinity, ease: 'easeInOut' }}
      />
    </div>

    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        className="text-center mb-12"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.55, ease: 'easeOut' }}
      >
        <span className="inline-flex items-center gap-2 rounded-full border border-[#5865F2]/35 bg-[#5865F2]/10 px-4 py-1.5 text-xs font-semibold tracking-wider text-[#9BA8FF] uppercase mb-4">
          Notre méthode
        </span>
        <h2 className="text-balance text-2xl md:text-3xl font-bold text-white mb-2">
          Comment ça <span className="text-[#5865F2]">marche ?</span>
        </h2>
        <p className="text-gray-400 text-sm">Auto-entrepreneur, artisan ou TPE : de l'idée à la mise en ligne en 3 étapes simples</p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
        {OFFER_STEPS.map((step, index) => {
          const Icon = step.icon;
          return (
            <motion.div
              key={step.id}
              className="text-center p-6 md:p-7 rounded-2xl border border-white/10 bg-gradient-to-b from-white/10 to-white/[0.03] backdrop-blur-sm"
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.35 }}
              transition={{ duration: 0.55, delay: index * 0.08, ease: 'easeOut' }}
              whileHover={{ y: -6, scale: 1.01 }}
            >
              <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#5865F2]/20 border border-[#5865F2]/35 text-[#9BA8FF]">
                <Icon className="h-6 w-6" />
              </div>
              <span className="inline-flex rounded-full border border-[#5865F2]/30 bg-[#5865F2]/10 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-[#9BA8FF] mb-3">
                Étape {step.id}
              </span>
              <h3 className="text-white font-semibold mb-2">{step.title}</h3>
              <p className="text-gray-300/90 text-sm leading-relaxed">{step.description}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);

export default OfferSteps;
